import { createAsyncThunk } from '@reduxjs/toolkit'
import { SymbolName } from '../../../types'
import { getAllTicker, TickerTuple } from '../../../api/v1/market'

export const getAllTickerAction = createAsyncThunk<
  Record<SymbolName, TickerTuple>
>('market/getAllTickerAction', async () => {
  return await getAllTicker()
})
